"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The IdentificationDetails model module.
 * @module model/IdentificationDetails
 * @version 3.0
 */
var IdentificationDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>IdentificationDetails</code>.
   * @alias module:model/IdentificationDetails
   */
  function IdentificationDetails() {
    _classCallCheck(this, IdentificationDetails);
    IdentificationDetails.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(IdentificationDetails, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>IdentificationDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IdentificationDetails} obj Optional instance to populate.
     * @return {module:model/IdentificationDetails} The populated <code>IdentificationDetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new IdentificationDetails();
        if (data.hasOwnProperty('identificationType')) {
          obj['identificationType'] = _ApiClient["default"].convertToType(data['identificationType'], 'String');
        }
        if (data.hasOwnProperty('identificationNumber')) {
          obj['identificationNumber'] = _ApiClient["default"].convertToType(data['identificationNumber'], 'String');
        }
        if (data.hasOwnProperty('identificationNumberSalt')) {
          obj['identificationNumberSalt'] = _ApiClient["default"].convertToType(data['identificationNumberSalt'], 'String');
        }
        if (data.hasOwnProperty('identificationValidFrom')) {
          obj['identificationValidFrom'] = _ApiClient["default"].convertToType(data['identificationValidFrom'], 'Date');
        }
        if (data.hasOwnProperty('identificationValidTo')) {
          obj['identificationValidTo'] = _ApiClient["default"].convertToType(data['identificationValidTo'], 'Date');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>IdentificationDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>IdentificationDetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['identificationType'] && !(typeof data['identificationType'] === 'string' || data['identificationType'] instanceof String)) {
        throw new Error("Expected the field `identificationType` to be a primitive type in the JSON string but got " + data['identificationType']);
      }
      // ensure the json data is a string
      if (data['identificationNumber'] && !(typeof data['identificationNumber'] === 'string' || data['identificationNumber'] instanceof String)) {
        throw new Error("Expected the field `identificationNumber` to be a primitive type in the JSON string but got " + data['identificationNumber']);
      }
      // ensure the json data is a string
      if (data['identificationNumberSalt'] && !(typeof data['identificationNumberSalt'] === 'string' || data['identificationNumberSalt'] instanceof String)) {
        throw new Error("Expected the field `identificationNumberSalt` to be a primitive type in the JSON string but got " + data['identificationNumberSalt']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} identificationType
 */
IdentificationDetails.prototype['identificationType'] = undefined;

/**
 * @member {String} identificationNumber
 */
IdentificationDetails.prototype['identificationNumber'] = undefined;

/**
 * @member {String} identificationNumberSalt
 */
IdentificationDetails.prototype['identificationNumberSalt'] = undefined;

/**
 * @member {Date} identificationValidFrom
 */
IdentificationDetails.prototype['identificationValidFrom'] = undefined;

/**
 * @member {Date} identificationValidTo
 */
IdentificationDetails.prototype['identificationValidTo'] = undefined;
var _default = exports["default"] = IdentificationDetails;